import MDTypography from "components/MDTypography";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import NotInterestedIcon from "@mui/icons-material/NotInterested";


function CTLNotificationBooleanCell({ value, suffix }) {
  if (value === true) {
    suffix = <CheckIcon fontSize="small" color="success" />;
  }else if (value === false) {
    suffix = <CloseIcon fontSize="small" color="error" />;
  } else if (value === null) {
    suffix = <NotInterestedIcon fontSize="small" color="warning" />;
  }
  return (
    <MDTypography variant="caption" fontWeight="medium">
      {suffix && (
        <MDTypography variant="caption" fontWeight="medium"  >
          &nbsp;&nbsp;{suffix}
        </MDTypography>
      )}
    </MDTypography>
  );
}

CTLNotificationBooleanCell.defaultProps = {
  suffix: "",
};

export default CTLNotificationBooleanCell;
